<template>
  <main class="content">
      <div class="row">
          <h1>
              History
          </h1>
      </div>
      <div class="topBar">
          <div class="topBar--item_left">
              <div class="input_text">
                  <v-select v-model="wallId" :searchable="false" placeholder="Click to select a wall" :options="walls"></v-select>
              </div>
              <button class="btn btn_blue u-mr1" @click="filter()">
                  Filter
              </button>
              <button v-if="query.wallId" class="btn btn_blue" @click="reset()">
                  X
              </button>
          </div>
      </div>
      <div class="table">
          <div class="table--row table--row_header">
              
              <div class="table--col" style="max-width:138px" v-bind:class= "getSortClasses('slotDate')" @click="sort('slotDate')">
                  <div class="table--col-title" href="#" >
                      Timeslot
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col u-unclickable" style="max-width:172px" v-bind:class= "getSortClasses('wall.name')" @click="sort('wall.name')">
                  <div class="table--col-title">
                      Wall
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:126px">
                  <div class="table--col-title">
                      Video
                  </div>
              </div>
              <div class="table--col" style="max-width:208px" v-bind:class= "getSortClasses('videoDetails.title')" @click="sort('videoDetails.title')">
                  <div class="table--col-title">
                      Information
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:220px" v-bind:class= "getSortClasses('user.first_name')" @click="sort('user.first_name')">
                  <div class="table--col-title">
                      User
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:280px" v-bind:class= "getSortClasses('transaction.amount')" @click="sort('transaction.amount')">
                  <div class="table--col-title">
                      Price
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
              <div class="table--col" style="max-width:297px" v-bind:class= "getSortClasses('status')" @click="sort('status')">
                  <div class="table--col-row">
                  </div>
                  <div class="table--col-title">
                      Status
                      <div class="table--col-arrows">
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                          <svg class="table--col-arrow" height="5" viewbox="0 0 9 5" width="9" xmlns="http://www.w3.org/2000/svg">
                              <path d="M4 .18l-4 3.2.96 1.28 3.52-2.8L8 4.66l.96-1.28-4-3.2c-.24-.24-.72-.24-.96 0z" fill-rule="nonzero">
                              </path>
                          </svg>
                      </div>
                  </div>
              </div>
          </div>
          <div class="table--row" v-for="video in videos">
              <div class="table--col" style="max-width:138px" v-if="video.startsAt">
                  <strong>
                      {{video.startsAt | moment("tz", video.wall.city.timezone, "MM/DD/YY")}}
                  </strong>
                  <span>
                      {{video.startsAt | moment("tz", video.wall.city.timezone, "hh:mma")}}
                  </span>
              </div>
              <div class="table--col" style="max-width:138px" v-if="video.slotDate && !video.startsAt">
                  <strong>
                      {{video.slotDate | moment("tz", video.wall.city.timezone, "MM/DD/YY")}}
                  </strong>
                  <span>
                      {{video.slotDate | moment("tz", video.wall.city.timezone, "hh:mma")}} - {{video.slotDate | moment("add", "15 minutes", "tz", video.wall.city.timezone, "hh:mma")}}
                  </span>
              </div>
              <div class="table--col" style="max-width:172px">
                  <strong>
                      {{video.wall.name}}
                  </strong>
                  <span>
                      {{video.wall.city.name}}
                  </span>
              </div>
              <div class="table--col" style="max-width:126px">
                  <a class="table--video" :href="video.videoDetails.link" target="_blank" v-bind:style="{ 'background-image': 'url(' + video.videoDetails.thumbnailUrl + ')' }">
                  </a>
              </div>
              <div class="table--col" style="max-width:208px">
                  <strong>
                      {{video.videoDetails.title}}
                  </strong>
                  <span>
                      {{video.videoDetails.duration | duration}}
                  </span>
              </div>
              <div class="table--col h-showEmail" style="max-width:220px">
                  <div class="table--col-user" style="max-width: 100%;">
                    <div class="table--col-user-img" v-bind:style="{ 'background-image': 'url(' + (video.user && video.user.picture ? video.user.picture.url : 'http://via.placeholder.com/40x40') + '?api_key=' + $parent.api_key + ')' }"></div>
                    <strong>
                        {{video.user ? video.user.firstName : ''}} {{video.user ? video.user.lastName : ''}}<br>
                        <span id="selectable">{{video.user ? video.user.email : ''}}</span>
                    </strong>
                  </div>
              </div>
              <div class="table--col" style="max-width:208px">
                <p v-if="video.transaction && video.transaction.amount">
                  {{video.transaction.amount.toFixed(2)}} {{video.transaction.currency.toUpperCase()}}
                </p>
                  
              </div>
              <div class="table--col" style="max-width:297px;">
                  <div class="table--col-row">
                      <button v-bind:class="getStatusClass(video.status)" style=" text-transform: capitalize">
                        {{video.status}}
                      </button>
                  </div>
              </div>
          </div>
      </div>
      <a class="btn btn_green u-fleft" @click="fetchResource()" v-if="nextPage">
          Load more
      </a>
      <loading :visible.sync="loadingVisible"></loading>
  </main>
</template>
<script>
import * as HttpService from '../../services/http.service'
import * as ListResource from '../../mixins/listResource.mixin';
import Loading from '../Loading.vue'
import vSelect from "vue-select"

export default {
  name: 'Pending',
  components: {Loading, vSelect},
  mixins: [ListResource],

  data () {
    return {
      model: 'videos',
      resource: 'videos/history',
      query: this.$route.query,
      videos: [],
      walls: [],
      wallId: '',
      sortOrder: 'desc',
      sortAttribute: 'slotDate',
      sortOrderFix: false
    }
  },
  created(){
    var self = this;
    HttpService.index('walls', {}, function(response, error){
      self.walls = response.result.data;
      self.walls = self.walls.map(item => {
        return {value: item.id, label: item.name}
      });

      if(self.query.wallId){
        self.wallId = self.walls.find(item => item.value == self.query.wallId);
      }
    });
  },
  methods: {
    
    filter(){
      if(this.wallId && this.wallId.value && this.wallId.value !== this.query.wallId){
        window.open('#/history?wallId=' + this.wallId.value, '_blank');
      }
      return false;
    },
    reset(){
      this.query = {};
      this.wallId = null;
      this.fetchResource();
    },
    getStatusClass(status){
      switch(status){
        case 'processing':
        case 'pending':
          return 'btn btn_grey';

        case 'rejected':
        case 'failed':
          return 'btn btn_red';

        case 'approved':
          return 'btn btn_green';
      }
    }
  }
}
</script>

<style scoped>
  
</style>


// WEBPACK FOOTER //
// History.vue?a14b7146